
import { mapGetters } from "vuex";
var aws = require("aws-sdk");

var stdtBucketName = "pepa.stdt";

function config() {
    var stdtBucketRegion = "eu-west-1";
    var stdtIdentityPoolId = "eu-west-1:df587e6d-b660-4117-812b-30abc53d4776";

    AWS.config.update({
        region: stdtBucketRegion,
        credentials: new AWS.CognitoIdentityCredentials({
            IdentityPoolId: stdtIdentityPoolId
        })
    });

    var s3 = new AWS.S3({ apiVersion: "latest" });
    return s3;
}


const STATUS_INITIAL = 0;
const STATUS_SAVING = 1;
const STATUS_SUCCESS = 2;
const STATUS_COMPLETE = 3;
const STATUS_FAILED = 4;

export const fileImportMixin = {
    computed: {
        ...mapGetters({ currentUser: "currentUser" }),
        isInitial() {
            return this.currentStatus === STATUS_INITIAL;
        },
        isSaving() {
            return this.currentStatus === STATUS_SAVING;
        },
        isSuccess() {
            return this.currentStatus === STATUS_SUCCESS;
        },
        isComplete() {
            return this.currentStatus === STATUS_COMPLETE;
        },
        isFailed() {
            return this.currentStatus === STATUS_FAILED;
        },
    },
    data() {
        return {
            completedPercentage: 0,
            currentStatus: null,
            remoteName: ''
        }
    },
    mounted() {
        this.currentStatus = STATUS_INITIAL;
    },
    methods: {
        async importDocument(formData) {
            this.currentStatus = STATUS_SAVING;
            var vm = this

            const files = formData.getAll('file');

            var file = files[0];

            var ext =
                Math.random()
                    .toString(36)
                    .substring(2, 9) +
                "." +
                file.name.split(".").pop();

            const name = this.currentUser.school + "_" + this.currentUser.name

            this.remoteName =
                name.replace(/\s+/, "") + "_" + file.name.replace(/\.[^/.]+$/, "") + ext;


            const filePath = this.remoteName.toLowerCase().trim();


            var params = {
                Bucket: stdtBucketName,
                Key: filePath,
                ContentType: file.type,
                Body: file,
                ACL: "private",
                ServerSideEncryption: "AES256"
            };

            var s3 = config();

            s3.upload(params)
                .on('httpUploadProgress', function (evt) {
                    vm.completedPercentage = Math.round(evt.loaded / evt.total * 100);
                    //console.log(`File uploaded: ${vm.completedPercentage}%`);
                }).send(function (err, data) {
                    if (err) {
                        // an error occurred, handle the error
                        console.log(err, err.stack);
                        vm.currentStatus = STATUS_FAILED;
                        return;
                    }

                    vm.currentStatus = STATUS_COMPLETE;
                })
        },
        refreshUpload() {
            this.currentStatus = STATUS_INITIAL;
            this.file = ''
            this.remoteName = ''
        },
        completed() {
            this.currentStatus = STATUS_COMPLETE
        }

    },
}